import { gql } from 'graphql-tag';
import {
  specificResourceAllocationFragment,
  specificResourceAllocationUserFragment
} from '~/modules/resourcing/common/fragments';
import { ResourceAllocationStatus } from '~/types';

export const GET_EXISTING_ALLOCATION_QUERY = gql`
  query Eager_GetExistingAllocation(
    $projectUri: String
    $filter: ResourceAllocationFilter
    $allocationStatusList: [ResourceAllocationStatus!]
    $consistentRead: Boolean
  ) {
    resourceAllocations(
      projectUri: $projectUri
      filter: $filter
      allocationStatusList: $allocationStatusList
      consistentRead: $consistentRead
    ) {
      resourceAllocations {
        ...SpecificResourceAllocation
        role {
          uri
          id
          displayText
        }
        user {
          ...SpecificResourceAllocationUser
        }
      }
    }
  }
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUserFragment}
`;

export const GET_EXISTING_ALLOCATION_QUERY_V2 = gql`
  query Eager_GetExistingAllocation_V2(
    $projectUri: String
    $filter: ResourceAllocationFilter
    $allocationStatusList: [ResourceAllocationStatus!]
    $consistentRead: Boolean
  ) {
    resourceAllocations: resourceAllocations2(
      projectUri: $projectUri
      filter: $filter
      allocationStatusList: $allocationStatusList
      consistentRead: $consistentRead
    ) {
      resourceAllocations {
        ...SpecificResourceAllocation
        role {
          uri
          id
          displayText
        }
        user {
          ...SpecificResourceAllocationUser
        }
      }
    }
  }
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUserFragment}
`;

export const HAS_EXISTING_ALLOCATION_QUERY = gql`
  query HasExistingAllocation(
    $projectUri: String
    $filter: ResourceAllocationFilter
    $allocationStatusList: [ResourceAllocationStatus!]
    $consistentRead: Boolean
  ) {
    resourceAllocations(
      projectUri: $projectUri
      filter: $filter
      allocationStatusList: $allocationStatusList
      consistentRead: $consistentRead
    ) {
      resourceAllocations {
        id
      }
    }
  }
`;

export const HAS_EXISTING_ALLOCATION_QUERY_V2 = gql`
  query HasExistingAllocation2(
    $projectUri: String
    $filter: ResourceAllocationFilter
    $allocationStatusList: [ResourceAllocationStatus!]
    $consistentRead: Boolean
  ) {
    resourceAllocations: resourceAllocations2(
      projectUri: $projectUri
      filter: $filter
      allocationStatusList: $allocationStatusList
      consistentRead: $consistentRead
    ) {
      resourceAllocations {
        id
      }
    }
  }
`;

export const getHasExistingAllocation = async ({
  apolloClient,
  projectUri,
  userUris,
  useResourceAllocationsV2Query = false
}) => {
  const { data, loading } = await apolloClient.query({
    query: useResourceAllocationsV2Query
      ? HAS_EXISTING_ALLOCATION_QUERY_V2
      : HAS_EXISTING_ALLOCATION_QUERY,
    variables: {
      filter: {
        users: userUris
      },
      projectUri,
      allocationStatusList: [ResourceAllocationStatus.Committed],
      consistentRead: true
    },
    fetchPolicy: 'network-only'
  });

  return {
    hasExistingAllocation: Boolean(
      data?.resourceAllocations?.resourceAllocations?.length
    ),
    isLoading: loading
  };
};
